import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable } from 'rxjs';
import { RequestList } from '..';

@Injectable({
  providedIn: 'root'
})
export class RequestFacade {
  constructor(public regbpService: RegbpService) {}

  getRequests(): Observable<RequestList> {
    return this.regbpService.getRequestList();
  }
}
